import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import React, {useContext, useEffect} from "react";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {NotificationContext} from "../../context/notification";
import {updateNotificationRead} from "../../services/notification/notification";
import {PaginateContext} from "../../context/paginate";
import {UpdateHeaderContext} from "../../context/update_header";

export function NotificationForm() {

  const {notification, modalOpen, setModalOpen, setNotifications} = useContext(NotificationContext)

  const {
    sortBy,
    sortType,
    rowsCount,
    active,
    setTotalRows
  } = useContext(PaginateContext)

  const {setUpdateNotifications} = useContext(UpdateHeaderContext)

  const notificationRead = async (id) => {
    const data = {
      id: id,
    };

    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(rowsCount),
      "offset": (parseInt(active) - 1) * parseInt(rowsCount),
    }).toString()

    let result;

    result = await updateNotificationRead(data, paginate);

    if (result.status === 202) {
      const {notificationList, total_count} = result.data;
      setNotifications(notificationList)
      setTotalRows(total_count)
      setUpdateNotifications(Date.now)
    }
  };

  useEffect(() => {
    if (notification?.push_status === "unread") {
      notificationRead(notification.id)
    }
  }, [notification]);


  const handleOpen = () => setModalOpen(!modalOpen);


  if (notification) {
    return (
      <>
        <Dialog open={modalOpen} handler={handleOpen} size="xl"
                animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
          <DialogHeader className="border-b">
            <Typography>مشاهده پیام</Typography>
          </DialogHeader>
          <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

            <div className="mb-4 border-b">
              <Typography color="blue-gray">
                {`عنوان: ${notification.title}`}
              </Typography>
            </div>

            <div className="mb-4 border-b">
              <Typography color="blue-gray">
                {`متن پیام: ${notification.description}`}
              </Typography>
            </div>

            <div className="mb-4">
              <Typography color="blue-gray">
                {`زمان ارسال: ${persianNumberFormat(notification.create_date.split(" ")[1] + " " + notification.create_date.split(" ")[0])}`}
              </Typography>
            </div>

          </DialogBody>
          <DialogFooter className="space-x-2">
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>بستن</span>
            </Button>
          </DialogFooter>
        </Dialog>
      </>
    );
  }
}